import { localStorage } from '../../database'
import { ISynchronizeStore } from './index'

const { UserDriver: Driver, Names } = localStorage
const { UserAccountStorage } = Names
const lastDateSync = Number(Driver.getItem(UserAccountStorage.LastSync, '0'))

export default {
  hasCriticalError: false,
  isSynchronizing: false,
  lastDateSync,
  newVersion: false,
  syncCount: 0,
} as ISynchronizeStore
